import React from 'react';
import { Facebook, Twitter, Smartphone, Copy } from 'lucide-react';

export default function MockupEditorial() {
  return (
    <div className="min-h-screen bg-[#F9F9F7] text-[#111] font-sans selection:bg-[#2e6c2e] selection:text-white pb-32">
      {/* Ticker */}
      <div className="w-full border-b border-[#111]/10 py-3 px-8 text-xs tracking-[0.2em] uppercase flex justify-between items-center bg-white sticky top-0 z-50">
        <span className="hidden md:inline">Live Updates</span>
        <span className="text-[#2e6c2e] font-serif italic mx-auto md:mx-0">Ktoś zagłosował na Gdańsk · 36s temu</span>
        <span className="hidden md:inline text-gray-400">Scootive 2026</span>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16">
        {/* Header */}
        <header className="flex flex-col md:flex-row justify-between items-start mb-24 gap-8">
           <img src="https://customer-assets.emergentagent.com/job_skate-tour-1/artifacts/ahdsblol_LOGO%20SCOOTIVE.svg" className="h-8 w-auto mix-blend-difference opacity-90" alt="Scootive" />
           <div className="text-left md:text-right border-l md:border-l-0 md:border-r border-[#111]/10 pl-6 md:pl-0 md:pr-6">
              <p className="text-xs uppercase tracking-[0.2em] text-gray-400 mb-2">Campaign ends in</p>
              <p className="font-serif text-3xl italic text-[#2e6c2e]" data-testid="countdown-timer">14d 08h 45m 12s</p>
           </div>
        </header>

        <div className="grid grid-cols-1 xl:grid-cols-12 gap-16 xl:gap-24 items-center">
           <div className="xl:col-span-8 relative">
              <div className="absolute -left-[5vw] top-1/2 -translate-y-1/2 text-[30vw] font-black text-black/[0.02] tracking-tighter whitespace-nowrap pointer-events-none select-none z-0">
                 TOUR
              </div>
              <h1 className="text-[14vw] xl:text-[9vw] leading-[0.85] tracking-tighter uppercase font-black relative z-10" style={{fontFamily: "'Anton', sans-serif"}}>
                 Scootive <br/>
                 <span className="text-transparent" style={{WebkitTextStroke: '2px #111'}}>On Tour</span><br/>
                 <span className="text-[#2e6c2e] font-serif italic font-light tracking-normal" style={{fontSize: '0.9em'}}>Sierpień</span> 26.
              </h1>
           </div>

           {/* Vote Card */}
           <div className="xl:col-span-4 bg-white p-12 border border-[#111]/10 shadow-2xl relative z-10">
              <div className="absolute -top-5 -left-5 w-10 h-10 bg-[#2e6c2e] rounded-full flex items-center justify-center text-white text-sm font-serif italic">1</div>
              <h2 className="font-serif text-3xl mb-12 italic text-[#111]">Oddaj swój głos.</h2>
              
              <div className="mb-10 border-b border-[#111]/20 pb-2 hover:border-[#2e6c2e] transition-colors group">
                 <label className="block text-xs uppercase tracking-widest text-gray-400 mb-4">Wybierz destynację</label>
                 <select data-testid="vote-city-select" className="w-full bg-transparent text-2xl outline-none appearance-none cursor-pointer font-serif italic text-[#111] group-hover:text-[#2e6c2e] transition-colors">
                    <option>Gdańsk, Pomorskie</option>
                    <option>Warszawa, Mazowieckie</option>
                    <option>Kraków, Małopolskie</option>
                    <option>Wrocław, Dolnośląskie</option>
                 </select>
              </div>

              <button data-testid="vote-submit-button" className="w-full bg-[#111] text-white py-6 px-6 uppercase tracking-[0.2em] text-sm hover:bg-[#2e6c2e] transition-colors mb-12 flex justify-between items-center group">
                 <span>Zatwierdź Wybór</span>
                 <span className="group-hover:translate-x-2 transition-transform">→</span>
              </button>

              <div className="flex justify-between items-center text-gray-400 border-t border-[#111]/5 pt-8">
                 <span className="text-[10px] uppercase tracking-[0.2em]">Share Campaign</span>
                 <div className="flex gap-6">
                    <Facebook size={16} data-testid="share-facebook" className="hover:text-[#2e6c2e] cursor-pointer transition-colors" />
                    <Twitter size={16} data-testid="share-twitter" className="hover:text-[#2e6c2e] cursor-pointer transition-colors" />
                    <Smartphone size={16} data-testid="share-whatsapp" className="hover:text-[#2e6c2e] cursor-pointer transition-colors" />
                    <Copy size={16} data-testid="share-copy" className="hover:text-[#2e6c2e] cursor-pointer transition-colors" />
                 </div>
              </div>
           </div>
        </div>

        {/* Ranking */}
        <div className="mt-40 xl:mt-56">
           <div className="flex items-end justify-between border-b border-[#111]/10 pb-6 mb-16">
              <h3 className="text-sm uppercase tracking-[0.2em]">Aktualny Ranking</h3>
              <span className="font-serif italic text-gray-400 text-sm">Top Destinations</span>
           </div>
           
           <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
              {[{n: "GDAŃSK", p: 85}, {n: "WARSZAWA", p: 60}, {n: "KRAKÓW", p: 45}].map((c,i) => (
                 <div key={i} className="group cursor-default">
                    <div className="flex justify-between items-baseline mb-6">
                       <span className="font-serif italic text-6xl text-gray-200 group-hover:text-[#2e6c2e] transition-colors duration-500">0{i+1}</span>
                       <span className="text-base font-bold tracking-[0.1em] uppercase">{c.n}</span>
                    </div>
                    <div className="h-px w-full bg-[#111]/10 relative overflow-hidden">
                       <div className="absolute top-0 left-0 h-full bg-[#2e6c2e] transition-all duration-1000 ease-out origin-left scale-x-0 group-hover:scale-x-100" style={{width: `${c.p}%`, transformOrigin: 'left', transform: 'scaleX(1)'}}></div>
                    </div>
                    <div className="text-right mt-4 text-xs tracking-widest text-gray-400 font-serif italic">{c.p}% Głosów</div>
                 </div>
              ))}
           </div>
        </div>
      </div>
    </div>
  );
}
